import { configAffiliateShopping, DataSourceWithConfig } from "@pub/config";
import { Ads, ContentBlock } from "@sphtech/dmg-design-system";
import ProductDeals from "@src/app/components/Modules/Product/ProductDeals";
import { AffiliateShoppingDataBlock } from "@src/app/types/ServerCustomContext";
import cx from "classnames";
import { TextLink } from "packages/design-system/src/components/Element/Typography";
import { ReactElement } from "react";

import styles from "../affiliateshopping.module.css";

type ProductsProps = {
  data: AffiliateShoppingDataBlock;
  dataSource?: DataSourceWithConfig;
  withDivider?: boolean;
};

export default function Products({
  data,
  dataSource,
  withDivider,
}: ProductsProps): ReactElement {
  const { title, titleZH, teasers, url } = data;
  const products = teasers?.filter((teaser) => teaser.deals);

  return (
    <ContentBlock
      heading={title}
      headingZH={titleZH}
      description={dataSource?.config?.desc}
      inlineGutter={true}
      withDivider={withDivider}
    >
      {products && (
        <>
          <div className={cx(styles.content, styles.productsContainer)}>
            <div className={styles.contentProductsContainer}>
              <ProductDeals
                data={{
                  items: products,
                }}
                isCarousel={false}
                options={{
                  sourceNameAsLabel: true,
                  discountPercentageBesidePrice: true,
                  imageCropType: "square",
                  hasBadge: true,
                  hasHeaderTitle: true,
                }}
              />

              {url && (
                <div className={cx(styles.ctaContainer)}>
                  <TextLink href={url}>
                    {dataSource?.config?.cta?.name || "View More"}
                    {configAffiliateShopping.viewMore?.icon}
                  </TextLink>
                </div>
              )}
            </div>
          </div>
          <Ads.AdsMidContent />
        </>
      )}
    </ContentBlock>
  );
}
